import { Clipboard } from '@angular/cdk/clipboard';
import { Injectable } from '@angular/core';
import { NotificationsService, NOTIFICATIONS } from 'src/app/core/service/notifications.service';
import { IrInvestorPositionDataDTO, IrPeriods, IrWithPeriodsDTO } from "../pojo/ir-common-classes";
import { CheckBoxSelector } from "../../shared/component/checkbox-selector/checkbox-selector.component";

@Injectable({
  providedIn: 'root',
})
export class IrInternalService {

  constructor(private clipboard: Clipboard,
    private notifications: NotificationsService) { }

  copyToClipboard(value: string): void {
    this.clipboard.copy(value);
    this.notifications.success(NOTIFICATIONS.COPIED_NO_TITLE);
  }


  processPeriodsInfo(response: IrWithPeriodsDTO): IrWithPeriodsDTO {
    if (response.periodsInfo) {
      const periodsInfo = new IrPeriods();
      periodsInfo.fromSelector = response.periodsInfo.fromSelector;
      periodsInfo.selected = response.periodsInfo.selected;
      periodsInfo.placeAllImgs();
      response.periodsInfo = periodsInfo;
    }
    return response;
  }

  mapInvestorsToCheckboxes(investors: IrInvestorPositionDataDTO[]): CheckBoxSelector[] {
    return investors.map((investor, index) => ({
      itemId: index,
      item: `
        <span class="font-3" data-qa="investor-name">${investor.investorName}</span>
        <br>
        <span class="font-5 black-9" data-qa="investor-id">${investor.investorId}, Holding: ${(investor.investorHolding * 100).toFixed(2)}%</span>
      `,
      chosen: investor.isInvestorSelected,
      disabled: !investor.isInvestorSelected,
    }));
  }
}

